import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from '@ngx-translate/core';

import { PostProvider } from "../../providers/post/post";
import { LanguageProvider } from '../../providers/language/language';

import { PostFile } from '../../models/post-file.model';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

import { API_URL } from '../../providers/api-url';

@IonicPage()
@Component({
  selector: 'page-public-post-detail',
  templateUrl: 'public-post-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PublicPostDetailPage {

  post: any;
  err: string;
  loading: boolean;

  dateLocale: string;

  constructor(private _sanitizer: DomSanitizer, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public languageProvider: LanguageProvider, public postProvider: PostProvider) {
    if (this.languageProvider.getByLocale(this.translate.currentLang)) {
      this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;
    } else {
      this.dateLocale = 'en';
    }
  }

  getPost() {
    this.loading = true;
    this.postProvider.getByID(this.navParams.get('id'))
      .subscribe(
        post => {
          if (!post.average_rating) {
            post.average_rating = 0;
          }
          this.post = post;
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  download(file: PostFile) {
    window.location.href = `${API_URL}/post-files/download/${file.id}`;
  }

  getBackground(img) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${img})`);
  }

  ionViewDidLoad() {
    this.getPost();
  }

}



// WEBPACK FOOTER //
// ./src/pages/public-post-detail/public-post-detail.ts